import { render, staticRenderFns } from "./AttachmentDownloadList.vue?vue&type=template&id=489a74d0&scoped=true"
import script from "./AttachmentDownloadList.vue?vue&type=script&lang=ts"
export * from "./AttachmentDownloadList.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentDownloadList.vue?vue&type=style&index=0&id=489a74d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489a74d0",
  null
  
)

export default component.exports